import invariant from 'invariant';
import firebase from './firebaseApi';

export function invariantLoggedIn() {
  const currentUser = firebase.auth().currentUser;
  invariant(currentUser !== null, 'User must be logged in for this function');
}
